import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';
import {
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';

import exportBibciteReferences from '../../helpers/bibciteExport';
import { Export, SearchAllContent } from '../../components';
import { FormikValues } from '../../components/SearchAllContent/types';

const HTTP_STATUS_OK = 200;

const SearchFull = () => {
  const { t } = useTranslation();
  const [exportLoading, setExportLoading] = useState(false);

  const startExport = async (values: FormikValues) => {
    setExportLoading(true);

    const result = await exportBibciteReferences(values);

    if (result.status === HTTP_STATUS_OK) {
      toast.success(t('components.export.success'));
    } else {
      toast.error(t('components.export.error'));
    }

    setExportLoading(false);
  };

  return (
    <Container>
      <SearchAllContent>
        <div className="row">
          <div className="col-12 mb-8 mb-lg-12">
            <SearchAllContent.SearchBar />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-4 mb-8 mb-lg-0">
            <SearchAllContent.Facets />
          </div>

          <div className="col-12 col-lg-8">
            <div className="d-flex justify-content-between align-items-center mb-8 mb-lg-6">
              <SearchAllContent.Stats />
              <SearchAllContent.SortBy />
            </div>

            <FormikWrapper
              initialValues={{}}
              onSubmit={(values: FormikValues) => startExport(values)}
            >
              <SearchAllContent.Results />
              <SearchAllContent.Pagination className="mt-8" />
              <Export isLoading={exportLoading} className="mt-10 mb-14" />
              <Toaster />
            </FormikWrapper>

          </div>
        </div>
      </SearchAllContent>
    </Container>
  );
};

export default SearchFull;
